
import { Product } from "@/types/product";

export const vpxRX1PROSDM: Product = {
  id: "vpx-sdm-dp",
  groupId: "avoip",
  name: "VPX-RX1-SDM",
  subtitle: "1Gb SDM Receiver",
  description: "The VPX-RX1-SDM is a Smart Display Module (SDM) card designed to bring Aurora's 1G AV over IP technology directly into compatible displays. This innovative solution eliminates the need for external receivers while providing all the advanced features of the VPX series in a compact form factor.\n\nSupporting resolutions up to 4K30 4:4:4 over 1G networks with Aurora's Mimix™ CODEC technology, the VPX-RX1-SDM delivers exceptional video quality with near-zero latency. The module integrates seamlessly with compatible displays, offering a clean, cable-free installation ideal for video walls and digital signage applications.\n\nWith its USB 2.0 support, 1G SFP and LAN connectivity options, the VPX-RX1-SDM is perfect for professional installations where space is limited but performance cannot be compromised.",
  features: [
    "4K60 4:4:4 UHD Decoder",
    "Zero Frame Latency (1.78ms)",
    "HDMI 2.0b, HDCP 2.2",
    "HDR10, HDR10+, Dolby Vision",
    "LPCM up to 12-channels, Dolby Digital Plus, Dolby TrueHD DTS HD Master Audio & ATMOS",
    "12 bits color depth processing, 16bits OSD",
    "Enterprise Security (AES 256, 802.1x, HTTPS, & SSH)",
    "Low Power Design",
    "Scaling & Seamless Switching",
    "MJPEG Preview up to 720p30",
    "Video Wall with Image Rotation",
    "1G LAN PoE and SFP for Fiber or 2nd RJ-45",
    "Channel Mapping with On-Screen Preview",
    "Roaming mouse & hotkeys",
    "Integrated Web Server for Configuration",
    "USB 2.0 Ports for Cameras, HID Devices, Mass Storage, etc.",
    "Dante® 2 Ch Audio License Options & Dante Controller"
  ],
  specifications: [
    "Form Factor: Intel® SDM-L",
    "Network: 1x RJ45 (1G), 1x SFP (1G)",
    "USB: 2x USB 2.0",
    "Control: Web GUI, API",
    "Maximum Resolution: 4K60 4:4:4",
    "HDR Support: Yes",
    "HDCP Support: 2.2",
    "Latency: <2ms",
    "Bandwidth: 850Mbps",
    "Power: SDM Interface",
    "Cooling: Passive"
  ],
  images: [
    "/lovable-uploads/1decffc0-ecd9-4c64-93d6-a1593705e7db.png",
    "/lovable-uploads/3aa9c5c4-b7da-44b0-aa4b-c71ff6f3cec7.png"
  ],
  applicationDiagram: "/lovable-uploads/VPX-RX1-SDM_Application_Diagram.png",
  slug: "vpx-rx1-pro-sdm",
  networkSpeed: "1gb"
};
